import IDataSourceConfiguration from '../Types/IDataSourceConfiguration'

export const tyontekijanakymaDataSourceConfiguration = (
    dataSourceMetadata: IDataSourceConfiguration
): IDataSourceConfiguration => ({
    ...dataSourceMetadata,
    DependsOn: ['TarvenakymaDataSource'],
})
